import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const RemoveGraphicModal = ({ isOpen, onClose, onConfirm, filename }) => {
  const handleOpenChange = (open) => {
    if (!open) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Ta bort grafik</DialogTitle>
          <DialogDescription>
            Är du säker på att du vill ta bort "{filename}"? Detta kommer att ta bort grafiken från alla sidor av bilen.
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter>
          <Button onClick={onClose} variant="secondary">
            Avbryt
          </Button>
          <Button onClick={handleConfirm} variant="destructive">
            Ta bort
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RemoveGraphicModal; 